module.exports = __webpack_public_path__ + "static/media/addBookingSuccess.86e81aff.png";